<template>

  <t-page>


    <b-modal size="lg" v-model="modalDeletedProduct" id="modal-expedition-product-deleted"
             ok-only
             title="Listagem de Ordens Excluídas">

      <t-msg v-if="productListDeleted.length > 0">Nenhum registro de produto excluído nesta expedição</t-msg>

      <div>

        <b-card-title>Qtd. excluída {{ productListDeleted.length }}</b-card-title>

        <t-table
            :items="productListDeleted"
            :fields="productListFields"
            class="table-danger"
            title-items="ordens excluídas"
            link-primary-column="originCodeLabel"
            table-bordered
            disable-actions-column
            disable-link-primary-column
            primary-key-column="expeditionProductId">
        </t-table>

      </div>



    </b-modal>


    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #title-buttons>

        <!--ESPECIFICO POLIMIX-->
        <PrintLabelDialog
            @onSubmit="onSubmitPrint" :label-id="2"
            :labelOptions="[{value:2,text:'Expedição'},{value:1,text:'Qualidade'}]"
            :disable-print="printItemsOptions.length===0"
            :list="printItemsOptions"
            :foreignKey="form.expeditionId" foreign-key-column="expeditionId">

          <div class="container-table-scroll">

            <table class="table table-hover table-scroll" v-if="printItemsOptions.length > 0">
              <thead>

              <th>
                Selecione as ordens para impressão
                <div>
                  <small>Marcar:
                    <a @click="selectAllItemsToPrint(true)" class="link-black">Todos</a> /
                    <a @click="selectAllItemsToPrint(false)" class="link-black">Nenhum</a>
                  </small>
                </div>

              </th>
              </thead>
              <tbody>
              <tr v-for="(item,index) in printItemsOptions" :key="index">
                <td class="d-flex">
                  <t-input checked :label="item.originCodeLabel" v-model="item.value"/>
                </td>
              </tr>
              </tbody>
            </table>


            <t-msg danger v-else>Nenhum bag inserido pela guia Produtos, insira antes de realizar a impressão</t-msg>

          </div>

        </PrintLabelDialog>


        <t-button @click="openModalDeletedProducts()"
                  outline-danger>
          <b-icon-trash-fill class="mr-1"></b-icon-trash-fill>
          Histórico Exclusões
        </t-button>

        <t-button @click="confirmReverse()"
                  outline-danger
                  v-show="(command === 'update' || command === 'view') && (form.finishedDate !== '' && form.finishedDate !== undefined)"
                  :sending="reverseFinish"
                  enable-loader
                  :title="!relationAccessSubValidation('sub-expedition-reverse-finish') ? 'Perfil de acesso não habilitado para estorno de finalização' : ''"
                  :disabled="!relationAccessSubValidation('sub-expedition-reverse-finish')">
          <b-icon-clipboard-x class="mr-1"></b-icon-clipboard-x>
          Estornar
        </t-button>

        <t-button @click="openDialogPrintLabel()" v-if="command !== 'insert'">
          <b-icon-printer></b-icon-printer>
          Imprimir Etiquetas
        </t-button>


        <!--Liberado mesmo que não esteja finalizado-->

        <t-button v-if="(command === 'update' || command === 'view') && form.qualityAppraisalPending === true"
                  :disabled="!relationAccessSubValidation('sub-generate-quality-appraisal')"
                  @click="downloadReport(7, form.expeditionId, 'LAUDO_QUALIDADE_' + form.expeditionNumber)">
          <b-icon-gear></b-icon-gear>
          Processar Laudo
        </t-button>

        <t-button v-if="(command === 'update' || command === 'view') && form.qualityAppraisalPending === false"
                  :disabled="!relationAccessSubValidation('sub-polimix-expedition-quality-report')"
                  @click="downloadReport(7, form.expeditionId, 'LAUDO_QUALIDADE_' + form.expeditionNumber)">
          <b-icon-file-earmark-check></b-icon-file-earmark-check>
          Imprimir Laudo
        </t-button>

      </template>

      <template #default="{status}">

        <t-input v-model="form[fieldKey]" hidden/>

        <t-form-tab title="Dados Básicos">

          <b-row>

            <t-input v-model="form.expeditionNumber" lpad="3" cols="3" label="Cód. Expedição" fixed/>

            <t-input v-model="form.originInvoiceCode" :add-error="error.originInvoiceCode" cols="3"
                     label="Nota Fiscal"/>

            <b-col cols="6">

              <t-input-person customer :status="status" :command="command" required :add-error="error.customerId"
                              v-model="form.customerId" @change="onChangeCustomerId"/>


            </b-col>

          </b-row>

          <b-row>
            <t-input v-model="form.expeditionStatusId" required cols="3" :options="typeExpeditionStatusOptions" select
                     first-default
                     label="Status Expedição"/>

            <t-input v-model="form.companyId"
                     :options="companyOptions"
                     cols="3" required
                     first-default
                     label="Empresa" select/>

            <t-input v-model="form.issueDate" required cols="3" date date-now label="Data de Emissão"/>
            <t-input v-model="form.finishedDate" fixed cols="3" datetime label="Data Finalizada"/>

          </b-row>

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <!-- <t-input-status v-model="form.status" class="mb-2"/>-->

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Produtos" hash="product"
                    :disabled="!relationAccessPageGeneral('stock-expedition-order-product')" lazy>
          <t-msg info v-if="form.customerId === 0">Por favor informe qual o cliente desta expedição para habilitar a aba
            de produtos
          </t-msg>

          <div v-else>

            <div>
              <label class="d-block mb-2 font-weight-bold">
                Formato de Inclus&atilde;o de Ordens de Fabrica&ccedil;&atilde;o
              </label>

              <b-row>
                <b-col cols="12" md="6" class="mb-3">
                  <b-card
                      :border-variant="formatInsert === 'A' ? 'primary' : null"
                      :bg-variant="formatInsert === 'A' ? 'light' : null"
                      class="cursor-pointer"
                      @click="selectFormat('A')"
                  >
                    <div class="d-flex align-items-center justify-content-between">
                      <b-card-title class="mb-0">Autom&aacute;tica</b-card-title>
                      <b-form-radio
                          v-model="formatInsert"
                          name="formatInsert"
                          value="A"
                          @click.stop
                      />
                    </div>

                    <div class="mt-2">
                      Com base no cliente, o sistema identifica as embalagens e toler&acirc;ncias aceitas e lista os
                      produtos dispon&iacute;veis por ordem de produ&ccedil;&atilde;o (FIFO).
                    </div>
                  </b-card>
                </b-col>

                <b-col cols="12" md="6" class="mb-3">
                  <b-card
                      :border-variant="formatInsert === 'M' ? 'primary' : null"
                      :bg-variant="formatInsert === 'M' ? 'light' : null"
                      class="cursor-pointer"
                      @click="selectFormat('M')"
                  >
                    <div class="d-flex align-items-center justify-content-between">
                      <b-card-title class="mb-0">Manual</b-card-title>
                      <b-form-radio
                          :disabled="!relationAccessSubValidation('sub-manual-insertion-source')"
                          v-model="formatInsert"
                          name="formatInsert"
                          value="M"
                          @click.stop
                      />
                    </div>

                    <div class="mt-2">
                      Escolha livremente sem regra de neg&oacute;cios de ordens de fabrica&ccedil;&atilde;o (modo
                      antigo).
                      <div class="text-danger mt-1" v-show="!relationAccessSubValidation('sub-manual-insertion-source')">
                        Requer valida&ccedil;&atilde;o especial.
                      </div>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>

            <ExpeditionOrderItem :foreign-key="form.expeditionId" :format-insert="formatInsert"
                                 :customer-rules="customerRules" :customer-rules-units="customerRulesUnits" :customer-rules-tolerances="customerRulesTolerances" :customer-id="form.customerId"/>

          </div>


        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ExpeditionOrderItem from "@/views/modules/stock/ExpeditionOrderProduct";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";
import PrintLabelDialog from "@/views/modules/general/PrintLabelDialog";
import ExpeditionService from "@/services/modules/stock/Expedition.service";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ExpeditionOrderForm',
  components: {PrintLabelDialog, ExpeditionOrderItem},
  data() {
    return {
      path: "stock/expedition-order", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "expeditionId",
      form: {
        expeditionId: 0,
        expeditionNumber: 0,
        companyId: 0,
        customerId: 0,
        expeditionStatusId: 0,
        finishedDate: "",
        qualityAppraisalPending: true,
        issueDate: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        originInvoiceCode: "",
        customerId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalDeletedProduct: false,
      typeExpeditionStatusOptions: [],
      productListDeleted: [],
      productListFields:[
        {key: "originCodeLabel", label: "Ordem de Fabricação"},
        {key: "logControl.deletedDate", label: "Data Exclusão", formatter: "datetime"},
        {key: "logControl.deletedUser", label: "Resp. Exclusão"},
      ],
      companyOptions: [],
      printItemsOptions: [],
      reverseFinish: false,
      formatInsert: "A",
      formatOptions: [
        {text: "Automática", value: "A"},
        {text: "Manual", value: "M"},
      ],
      loadCustomerRules: false,
      customerRules: {},
      customerRulesUnits: "",
      customerRulesTolerances: "",
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.typeExpeditionStatusOptions = response.typeExpeditionStatusOptions
        this.companyOptions = response.companyOptions
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true


    },
    async onSubmit() {

      await http.count("stock/expedition-order-product", this.form.expeditionId).then(async (count) => {

        if (count > 0) {
          await this.setSendingDefault()
        } else {
          ui.msgError(this, "Insira pelo menos 1 produto para gravar a Expedição");
        }

      }).catch(error => this.responseError(error))

      //

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    selectFormat(val) {

      if (val === "M" && !this.relationAccessSubValidation('sub-manual-insertion-source')) {
        ui.msgError(this, "Você não possui validação especial para inserção manual de produtos");
      } else {
        this.formatInsert = val;
      }
    },

    async openDialogPrintLabel() {

      //Atualiza listagem de produtos inseridos
      await http.list("stock/expedition-order-product?sorted=originCodeLabel&expeditionId=" + this.form.expeditionId).then((list) => {

        this.printItemsOptions = []

        for (const item of list) {

          //originCodeLabel
          const newItem = {
            expeditionProductId: item.expeditionProductId,
            originCodeLabel: item.originCodeLabel,
            value: true,
          }

          this.printItemsOptions.push(newItem)

        }

        //Abre dialogo de impressão de etiqueta
        this.openDialogForm('modal-print-label-2')

      }).catch(error => this.responseError(error))

    },

    async onSubmitPrint() {

      ui.msg(this, "Impressão Etiqueta Expedição", "Impressão enviada com sucesso!");

    },

    selectAllItemsToPrint(checked) {

      for (let item of this.printItemsOptions) {
        item.value = checked
      }

    },

    async confirmReverse() {

      ui.msgConfirm(this, 'ESTORNO DA FINALIZAÇÃO', '<span>Tem certeza que deseja realizar o estorno da finalização desta Expedição <b>' + this.form.expeditionNumber + '</b>?<br /><br />Obs.: Irá estornar o estoque e voltará para pendente.</span>', async () => {

        this.reverseFinish = true

        await ExpeditionService.reverse(this.form.expeditionId).then(async () => {

          await this.goPath(this.userAuth.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Expedição ' + this.form.expeditionNumber + ' foi estornada com sucesso!'
          })

        }).catch(error => ui.generalResponseError(this, error))

        this.reverseFinish = false

      })

    },

    async onChangeCustomerId(val) {

      if (val > 0) {

        this.loadCustomerRules = false

        await http.get("stock/expedition-order/checkCustomerRules/" + val).then((response) => {
          this.customerRules = response.data

          this.customerRulesUnits = this.customerRules.units
              .map(item => item.name)
              .sort((a, b) => a.localeCompare(b, 'pt-BR'))
              .join(', ')

          this.customerRulesTolerances = this.customerRules.tolerances
              .map(item => item.name)
              .sort((a, b) => a.localeCompare(b, 'pt-BR'))
              .join(', ')

          this.loadCustomerRules = true
        })

      }

    },

    async openModalDeletedProducts(){

      this.pageFormIsLoaded = false

      await http.get("/stock/expedition-order-product/getListDeleted/" + this.form.expeditionId).then(async (response) => {

        this.pageFormIsLoaded = true
        this.productListDeleted = response.data

        this.pageFormIsLoaded = true
        this.openModal('modal-expedition-product-deleted')

      }).catch(error => {
        this.pageFormIsLoaded = true
        ui.generalResponseError(this, error)
      })
      
    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>